module.exports = __webpack_public_path__ + "static/img/14000652.897de1d3.png";